// extracted by mini-css-extract-plugin
module.exports = {"phone":"_3ea6fa5da8--phone--pigCj","hover-text":"_3ea6fa5da8--hover-text--l0QU1"};